<template>

  <genelarama apiname="GenelTanitimAra" v-bind:aktifmi="aktifmi" :label="getLabel" :tip="tipToInt" v-model="Model"></genelarama>

</template>

<script>

import genelarama from '@/components/app/coper/comp/genelarama.vue'

export default {
    props:["value","tip","aktifmi"],
    components: {
      genelarama,
    },

    computed: {
      Model: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue )
        },
      },
      getLabel:{
         get : function(){
           var r = this.tip
          if (this.tip=="Bolge"){r = this.$t('Region')}
          if (this.tip=="Bölge"){r = this.$t('Region')}
          if (this.tip=="Bolum"){r = this.$t('Department')}
          if (this.tip=="Bölum"){r = this.$t('Department')}
          if (this.tip=="Bölüm"){r = this.$t('Department')}
          if (this.tip=="Yonetim"){r = this.$t('Management')}
          if (this.tip=="Yönetim"){r = this.$t('Management')}
          if (this.tip=="Departman"){r = this.$t('Department-v2')}
          if (this.tip=="AltDepartman"){r = this.$t('Sub-Department')}
          if (this.tip=="VizeFiyatTipi"){r = this.$t('Visa-Price-Type')}
          if (this.tip=="AcenteDepartman"){r = this.$t('Agency-Department')}
          if (this.tip=="SebepKod"){r = this.$t('Reason-Code-v2')}
          if (this.tip=="OtelFiyatKod"){r = this.$t('Hotel-Price-Code')}
          if (this.tip=="CariTransferKod"){r = this.$t('Transfer-Code')}
          if (this.tip=="CariTevkifatKod"){r = this.$t('Withholding-Code')}
          if (this.tip=="CariKdvKod"){r = this.$t('VAT-Code')}
          if (this.tip=="CariKdvIstisnaKod"){r = this.$t('VAT-Exception-Code')}
          if (this.tip=="CariInternetSatisWebAdresi"){r = this.$t('Internet-Sales-Web-Address')}
          if (this.tip=="CariInternetSatisDigerAciklama"){r = this.$t('Internet-Sales-Other-Explanation')}
          if (this.tip=="CariInternetSatisOdemeAracisi"){r = this.$t('Internet-Sales-Payment-Intermediary')}

           return r
         }
      },

      tipToInt : function(){
        var r=-1
        if (this.tip=="Bolge"){r = 0}
        if (this.tip=="Bolum"){r = 1}
        if (this.tip=="Yonetim"){r = 2}
        if (this.tip=="Departman"){r = 3}
        if (this.tip=="AltDepartman"){r = 4}
        if (this.tip=="VizeFiyatTipi"){r = 5}
        if (this.tip=="AcenteDepartman"){r = 6}
        if (this.tip=="SebepKod"){r = 7}
        if (this.tip=="OtelFiyatKod"){r = 8}
        if (this.tip=="CariTransferKod"){r = 301}
        if (this.tip=="CariTevkifatKod"){r = 302}
        if (this.tip=="CariKdvKod"){r = 303}
        if (this.tip=="CariKdvIstisnaKod"){r = 304}
        if (this.tip=="CariInternetSatisWebAdresi"){r = 305}
        if (this.tip=="CariInternetSatisDigerAciklama"){r = 306}
        if (this.tip=="CariInternetSatisOdemeAracisi"){r = 307}

        return r;
    },

    },


    data () {
      return {

      }
  },

}


</script>